/**
 * Il menu in alto della BI (Davide 29/10/2026): «un menu superiore per vedere
 * le cose con ordine e con dettaglio, la prima invece voglio il riepilogo».
 * La scheda scelta sta nell'indirizzo (``?vista=``): si ricarica e si condivide.
 */

export const VISTE = [
  { id: "riepilogo", nome: "Riepilogo" },
  { id: "utile", nome: "Utile vero" },
  { id: "canali", nome: "Canali e fornitori" },
  { id: "prodotti", nome: "Prodotti" },
  { id: "resi", nome: "Resi e sostituzioni" },
  { id: "problemi", nome: "Problemi" },
  { id: "costi", nome: "Costi e stati" },
] as const;

export type VistaId = (typeof VISTE)[number]["id"];

export function vistaDa(valore: string | null): VistaId {
  return VISTE.find((v) => v.id === valore)?.id ?? "riepilogo";
}

export function Schede({ valore, onChange }: { valore: VistaId; onChange: (v: VistaId) => void }) {
  return (
    <nav
      aria-label="Sezioni della BI"
      className="mb-4 max-md:-mx-3 max-md:overflow-x-auto max-md:px-3"
    >
      <ul className="flex w-max gap-1 border-b border-line">
        {VISTE.map((v) => {
          const attiva = v.id === valore;
          return (
            <li key={v.id}>
              <button
                type="button"
                aria-current={attiva ? "page" : undefined}
                onClick={() => onChange(v.id)}
                className={`-mb-px h-[40px] border-b-2 px-3.5 text-[14px] font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 max-md:h-11 max-md:text-[15px] ${
                  attiva ? "border-ink text-ink" : "border-transparent text-ink-3 hover:text-ink"
                }`}
              >
                {v.nome}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
